import styled from 'styled-components'

const MainPage = styled.div`
  margin: 8px;
  min-height: calc(100vh - 16px);
  display: flex;
  flex-direction: column;
  @media (max-width: 1120px) {
    margin: 4px;
  }
`
export default {
  MainPage,
}
